// src/components/ranking/Podium.jsx
// The top three on a podium: gold in the middle, silver on the left, bronze on the right.
import React from 'react';
import { CLASSIC_RANKING, formatScore } from '../../utils/ranking';

const MEDALS = { 1: 'gold', 2: 'silver', 3: 'bronze' };
const LABELS = { 1: 'Gold', 2: 'Silver', 3: 'Bronze' };

const defaultNameOf = (row) => `${row.firstName} ${row.lastName}`;

function Place({ row, ranking, nameOf }) {
    const medal = MEDALS[row.rank];
    return (
        <li className={`podium-place ${medal}`} aria-label={`${LABELS[row.rank]}: ${nameOf(row)}`}>
            <div className="podium-medal" aria-hidden="true">
                {row.rank}
            </div>
            <div className="podium-name">{nameOf(row)}</div>
            <div className="podium-score">
                {formatScore(row.score, ranking)} {ranking === CLASSIC_RANKING ? 'points' : ranking.unit.toLowerCase()}
            </div>
            <div className="podium-detail">
                {row.matchesWon}–{row.matchesLost} in matches · {row.pointDiff > 0 ? `+${row.pointDiff}` : row.pointDiff}
            </div>
            <div className="podium-block" aria-hidden="true" />
        </li>
    );
}

function Podium({ standings, ranking = CLASSIC_RANKING, nameOf = defaultNameOf }) {
    const top = standings.filter((row) => row.rank <= 3);
    if (top.length === 0) return null;
    // silver | gold | bronze, whoever exists
    const order = [2, 1, 3].map((rank) => top.find((row) => row.rank === rank)).filter(Boolean);
    return (
        <ol className="podium" aria-label="Podium">
            {order.map((row) => (
                <Place key={row.playerId ?? row.teamId} row={row} ranking={ranking} nameOf={nameOf} />
            ))}
        </ol>
    );
}

export default Podium;
